<script setup>
import Container from '@js/Components/Container/Container.vue'
import HeroCheckmark from '@js/Components/Marketing/Heros/HeroCheckmark/HeroCheckmark.vue'
import RentbirdPlusEmailInput from '@js/Components/Forms/RentbirdPlusEmailInput/RentbirdPlusEmailInput.vue'
import Image from '@js/Components/Image/Image.vue'
import ImageRentbirdPlusHeroMobile from '@images/people/rentbird-plus-hero-mobile.png'
import ImageRentbirdPlusHeroDesktop from '@images/people/rentbird-plus-hero-desktop.png'
import ImageKey from '@images/icons/key.png'
import RentbirdPlusLogo from '@js/Components/Logos/RentbirdPlusLogo/RentbirdPlusLogo.vue'
import { useIsMobile } from '@js/App/Utils/BrowserDetection'

const { isMobile } = useIsMobile()
</script>
<template>
  <div class="bg-[#28214B] pt-[24px] lg:pt-[32px]">
    <Container class="pb-8 pt-4 lg:pt-8 lg:pb-16 flex justify-center">
      <RentbirdPlusLogo :size="isMobile ? 'xs' : 'md'" :href="$getLocalizedUrl('rentbird-plus-welcome')" />
    </Container>
    <Container :large="true" class="lg:pb-[64px]">
      <div class="block lg:flex lg:items-center xl:items-end">
        <div class="lg:flex-grow lg:mr-2">
          <div class="">
            <div
              class="text-[#E71C77] bg-pink-100 rounded-full py-[2px] px-[10px] lg:py-[4px] lg:px-[12px] inline-block"
            >
              {{ $trans('RentbirdPlusGuaranteeHero.New') }}
            </div>
          </div>

          <h1
            class="pt-[16px] text-white text-5xl lg:text-6xl lg:font-bold font-medium"
            v-html="$trans('RentbirdPlusGuaranteeHero.Title')"
          />

          <HeroCheckmark class="mt-[24px] lg:mt-[16px] mb-[8px] lg:mb-[14px]">
            <span v-html="$trans('RentbirdPlusGuaranteeHero.Item1')" />
          </HeroCheckmark>

          <HeroCheckmark class="mb-[8px] lg:mb-[14px]">
            <span v-html="$trans('RentbirdPlusGuaranteeHero.Item2')" />
          </HeroCheckmark>

          <HeroCheckmark class="mb-[24px] lg:mb-[32px]">
            <span v-html="$trans('RentbirdPlusGuaranteeHero.Item3')" />
          </HeroCheckmark>

          <RentbirdPlusEmailInput class="mb-[40px]" />
        </div>
        <div class="lg:min-w-[231px] lg:max-w-[231px] xl:min-w-[441px] xl:max-w-[441px]">
          <div class="relative overflow-hidden lg:overflow-visible pb-[64px] lg:pb-0">
            <Image :src="ImageRentbirdPlusHeroMobile" class="w-full lg:hidden" />
            <Image :src="ImageRentbirdPlusHeroDesktop" class="w-full hidden lg:block" />
            <Image
              :src="ImageKey"
              class="absolute bottom-[-16px] right-[-35px] w-[190px] h-[190px] rotate-[270deg] lg:w-[290px] lg:h-[290px] lg:left-[-140px] lg:bottom-[20px] lg:right-auto"
            />
          </div>
        </div>
      </div>
    </Container>
  </div>
</template>
